<template>
  <div>
    <b-container id="home-news" fluid class="section">
      <div
        class="title d-flex justify-content-between align-items-center flex-wrap first"
      >
        <h2>Latest News</h2>
        <router-link class="nav-route" to="/news">
          <b-button variant="primary">View All</b-button>
        </router-link>
      </div>
      <div class="carousel-outer">
        <div @mouseover="onHover" @mouseout="leaveHover" class="carousel">
          <button
            aria-label="show previous article button"
            @click="prevImage"
            class="carousel-button left"
          >
            <font-awesome icon="arrow-left" />
          </button>
          <img
            v-for="(article, index) in this.news"
            class="carousel-image"
            v-bind:class="{ active: index === carouselIndex }"
            :key="article.id"
            :src="news[index].image.download_url"
            :alt="news[index].display_title"
          />
          <div
            v-if="this.news != undefined && this.news.length > 0"
            class="carousel-text-section"
          >
            <h5 class="carousel-title">{{ this.news[this.carouselIndex].display_title }}</h5>
            <p class="carousel-summary">{{ news[carouselIndex].summary }}</p>
            <router-link :to="'/news/' + news[carouselIndex].id" tag="a"
              >Read More</router-link
            >
          </div>
          <button
            aria-label="show next article button"
            @click="nextImage"
            class="carousel-button right"
          >
            <font-awesome icon="arrow-right" />
          </button>
        </div>
        <b-progress
          role="progressbar"
          aria-label="carousel progress bar"
          class="carousel-progress"
          height="4px"
          :value="((carouselIndex + 1) / news.length) * 100"
        ></b-progress>
      </div>
    </b-container>
  </div>
</template>

<script>
import Piece from "@/components/Article.vue";

export default {
  name: "News",
  props: ["news"],
  components: {
    Piece,
  },
  data() {
    return {
      carouselIndex: 0,
      carouselHovered: false,
    };
  },
  created() {
    setInterval(() => {
      if (this.carouselHovered === false) {
        this.nextImage();
      }
    }, 5000);
  },
  methods: {
    nextImage() {
      this.carouselIndex < this.news.length - 1
        ? (this.carouselIndex += 1)
        : (this.carouselIndex = 0);
    },
    prevImage() {
      this.carouselIndex > 0
        ? (this.carouselIndex -= 1)
        : (this.carouselIndex = this.news.length - 1);
    },
    onHover() {
      this.carouselHovered = true;
    },
    leaveHover() {
      this.carouselHovered = false;
    },
  },
};
</script>

<style lang="scss">
.carousel-outer {
  overflow: hidden;
  max-width: 100%;
  display: block;
  box-sizing: border-box;

  background-color: rgba($color: white, $alpha: 0.7);
  padding: 1%;
  padding-top: 2%;
  border-radius: 6px;
}

.carousel {
  display: flex;
  flex-direction: row;
  gap: 5%;

  justify-content: center;
  align-items: flex-start;

  max-width: 90%;

  margin-left: auto;
  margin-right: auto;

  @include media-breakpoint-down(md) {
    flex-direction: column;
    align-items: center;
    max-width: 100%;
  }
}

.carousel-image {
  opacity: 0;
  position: absolute;
  z-index: 900;

  width: 55% !important;
  aspect-ratio: 16/9;

  object-fit: cover !important;
  object-position: center !important;

  top: 0;
  left: 0;

  @include media-breakpoint-down(md) {
    width: 100% !important;
  }
}

.carousel-image.active {
  opacity: 1;
  position: relative;

  transition: opacity 1.5s;
}

.carousel-text-section {
  display: flex;
  flex-direction: column;
  justify-content: center;

  width: 40%;

  @include media-breakpoint-down(md) {
    width: 95%;
    margin-top: 5%;
  }
}

.carousel-button {
  position: absolute;
  z-index: 901;

  height: 32px;
  width: 32px;
  background-color: rgba($color: $secondary-color, $alpha: 0.5);
  border: 2px, solid, rgba($color: $secondary-color, $alpha: 0.5);
  border-radius: 2px;

  align-self: center;

  @include media-breakpoint-down(sm) {
    bottom: -12%;
  }
}

// icons
.carousel-button * {
  color: $primary-color;
  height: 100%;
}

.carousel-button.right {
  right: -4%;

  @include media-breakpoint-down(md) {
    right: 2%;
  }
}

.carousel-button.left {
  left: -4%;

  @include media-breakpoint-down(md) {
    left: 2%;
  }
}

.progress-bar {
  background-color: $primary-color !important;
}

.carousel-progress {
  width: 50%;
  margin: auto;
  margin-top: 2em;
  background-color: rgba($color: $secondary-color, $alpha: 0.5) !important;

  @include media-breakpoint-down(md) {
    margin-top: 4em;
  }
}

.first {
  margin-top: 5em;
}

.carousel-title {
  margin-left: auto;
  margin-right: auto;
}
</style>
